import React from 'react';
import { Image, StyleSheet } from 'react-native';

import { Button } from '@/components/ButtonComponent';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';

import { ds } from '../lib/design.system';
import { EntryConfirmationShell } from './EntryConfirmationShell';

type Props = {
    onClose: () => void;
    title: string;
    description: string;
    buttonLabel: string;
};

/**
 * Displays a timeout/processing state within the entry confirmation flow
 * On picks, is shown when the polling mechanism times out waiting for an entry submission result
 * The entry may still be processing. This state lets the user acknowledge and exit
 */
export const EntryConfirmationTimeout = ({ onClose, title, description, buttonLabel }: Props) => (
    <EntryConfirmationShell onClose={onClose}>
        <Box flex={1} justifyContent="center">
            <Box flex={1} justifyContent={'center'}>
                <Box alignItems="center" paddingHorizontal={'s40'}>
                    <Box width={120} height={120} alignItems="center" justifyContent="center" paddingBottom={'s16'}>
                        <Image
                            source={require('@/assets/images/entry_confirmation_processing.png')}
                            style={styles.image}
                            resizeMode="cover"
                        />
                    </Box>
                    <Text
                        variant="headlineLarge"
                        textAlign="center"
                        color={ds.colorToken.text.primary}
                        paddingBottom={'s8'}
                    >
                        {title}
                    </Text>
                    <Text
                        variant="bodyMedium"
                        textAlign="center"
                        color={ds.colorToken.text.primary}
                        style={styles.description}
                    >
                        {description}
                    </Text>
                </Box>
            </Box>
            <Box padding={'s16'}>
                <Button
                    label={buttonLabel}
                    hierarchy="primary"
                    onPress={onClose}
                    testID="submitEntryTimeoutButton"
                    textStyle={styles.buttonLabel}
                />
            </Box>
        </Box>
    </EntryConfirmationShell>
);

const styles = StyleSheet.create({
    image: {
        width: 120,
        height: 120,
    },
    description: {
        opacity: 0.6,
    },
    buttonLabel: {
        color: ds.colorValue.text.brandoninverse,
    },
});
